import styled, {keyframes} from 'styled-components';

import {colors, font} from 'theme';

const rotate = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;

export const ModalContainerCentered = styled.div`
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    align-items: center;
`;

export const LoadingSubtitle = styled.div`
    box-sizing: border-box;
    width: auto;
    height: auto;
    font-family: ${font.family.primary};
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: ${colors.textPrimary};
`;

export const Loader = styled.div`
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: ${rotate} 2.3s infinite linear;
    margin-bottom: 60px;
`;
